import ReCAPTCHA from "react-google-recaptcha";

const Recaptcha = ({ onChange }) => {
    const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    return <ReCAPTCHA sitekey={RECAPTCHA_KEY} onChange={onChange} />;
};

export default Recaptcha;
